import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import CertificationSlider from './components/CertificationSlider';

// Pages
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Products from './pages/Products';
import Quality from './pages/Quality';
import ContactUs from './pages/ContactUs';
import Careers from './pages/Careers';
import Infrastructure from './pages/Infrastructure';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about/about-us" element={<AboutUs />} />
            <Route path="/about/infrastructure" element={<Infrastructure />} />
            <Route path="/about/careers" element={<Careers />} />
            <Route path="/products" element={<Products />} />
            <Route path="/quality" element={<Quality />} />
            <Route path="/contact-us" element={<ContactUs />} />
          </Routes>
        </main>
        <CertificationSlider />
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
